module.exports = __webpack_public_path__ + "img/boy.4146f194.png";